export default () => ({
  perPage: 30,
});
